import { APP_MODULE } from './../module-pages';
import { WebsocketActions } from './../redux/wstomp/websocket-actions';
import { LoginGuard } from './pages/auth/check-login.guard';
import { PlayerService } from './../providers/player-service/player-service';
import { CompetitionService } from './../providers/competition-service/competition-service';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy, NavParams } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppRoutingModule } from './app-routing.module';
import { MyApp } from './app.component';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { RemoteHttpService } from 'src/remote-http';
import { AuthenticationService } from 'src/authentication-service';
import { Preference } from 'src/storage/preference';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { VolatileStorage } from 'src/storage/volatile-storage';
import { SessionActions, SessionDataService, SessionEffects } from 'src/redux/session';
import { combineReducers, compose, StoreModule } from '@ngrx/store';
import { DeviceService } from 'src/providers/device-service/device-service';
import { DeviceActionEffects, DeviceDataService } from 'src/redux/device';
import { ConnectionService } from 'src/providers/connection-service/connection-service';
import { BatteryStatus } from '@awesome-cordova-plugins/battery-status/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { FiletransferService } from 'src/providers/filetransfer-service/filetransfer-service';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { Custom_RequestMethod } from 'src/providers/common-service';
import { PlayerPerformanceService } from 'src/providers/playerPerformance-service/playerPerformance-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { EventLogService } from 'src/providers/eventlog-service/eventlog-service';
import '../../node_modules/chart.js/dist/Chart.bundle.js';
import '../../node_modules/chartjs-color-string/color-string.js';
import '../../node_modules/chartjs-color/index.js';
import { ScorecardStorageService } from 'src/providers/scorecard-service/scorecard-storage-service';
import { PlayerHomeActions, PlayerHomeDataService, PlayerHomeEffects } from 'src/redux/player-home';
import { Drivers } from '@ionic/storage';
import { CurrentScorecardEffects } from 'src/redux/scorecard';
// import { DatePicker } from '@awesome-cordova-plugins/date-picker/ngx';
import { localStorageSync } from 'src/redux/storage-sync';
import { AppSync } from 'src/redux/appstate';
import { RootReducer } from 'src/redux/root-reducer';
import { ReduxProviders } from '../redux/redux-providers';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ImageService } from 'src/providers/image-service/image-service';
import { MYGOLF_PROVIDERS } from 'src/providers';
import { NativeProviders } from 'src/native-plugin-providers';
import { EffectsModule } from '@ngrx/effects';
import { WebsocketEffects } from 'src/redux/wstomp';
import { NgCalendarModule } from 'ionic2-calendar';
import { PLAYER_MODULE_PAGES } from '../player-module-pages';
import { PLAYER_MODULE_PIPES } from './../player-module-pipes';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { ManUpModule, ManUpService, TRANSLATE_SERVICE } from 'ionic-manup';
import { RecentClubPage } from './pages/performance/recent-club/recent-club.page';
import { ScorerStateEffects } from 'src/redux/scorer-state';
import { QuillModule } from 'ngx-quill';
import { CalendarModule } from 'ion2-calendar';
import { DateRangePicker } from './shared/date-range-picker.component';
import { FormsModule } from '@angular/forms';
import { SelectDaysComponent } from './shared/select-days/select-days.component';
import { GenerateReportPipe } from './pages/booking/generate-report.pipe';
import { PathPreserveQueryLocationStrategy } from 'src/custom/preserve-query-params';
import { LocationStrategy } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PickListModule } from 'primeng/picklist';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

const prodReducer = compose(
  localStorageSync({
    keys: AppSync,
    prefix: 'mygolf2uapp',
    rehydrate: true,
  }),
  combineReducers
)(RootReducer);
export function appReducer(state: any = {}, action: any) {
  return prodReducer(state, action);
}

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

@NgModule({
  declarations: [
    MyApp,
    DateRangePicker,
    SelectDaysComponent,
    // RecentClubPage
    // ...PLAYER_MODULE_PIPES,
    // ...PLAYER_MODULE_PAGES
  ],
  imports: [
    QuillModule.forRoot({
      modules,
      placeholder: 'Start writing.....',
    }),
    CalendarModule.forRoot(),
    FormsModule,
    // HttpModule,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    // StoreModule.forRoot({ reducers: appReducer }),
    StoreModule.forRoot(
      { reducers: appReducer },
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
          // "strictStateSerializability": true,
          // "strictActionSerializability": true,
        },
      }
    ),
    // IonicModule.forRoot(MyApp,{PLAYER_MODULE_PAGES}),
    IonicStorageModule.forRoot({
      name: 'myname',
      driverOrder: [Drivers.IndexedDB], // , Drivers.LocalStorage
    }),
    EffectsModule.forRoot([DeviceActionEffects, SessionEffects, CurrentScorecardEffects, WebsocketEffects, ScorerStateEffects]),
    NgCalendarModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ...APP_MODULE,
    PickListModule,
    // CommonConfirmationModalModule
    DragDropModule,
  ],
  providers: [
    Custom_RequestMethod,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    // { provide: TRANSLATE_SERVICE, useClass: TranslateService },
    ...NativeProviders,
    ...MYGOLF_PROVIDERS,
    ...ReduxProviders,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6LcJQM0ZAAAAAGVMmPWu6tTK4JzCj_TvNXm4gOIy',
      } as RecaptchaSettings,
    },
    { provide: LocationStrategy, useClass: PathPreserveQueryLocationStrategy },
  ],
  bootstrap: [MyApp],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
